import { Model } from '@vuex-orm/core';
import STORE from '@/store/STORE';
import ProcessStages from './ProcessStages';

const { name } = STORE.modules.trial;

export default class Trial extends Model {
  static entity = `${ name }`;

  static fields() {
    return {
      id: this.attr(null),
      status: this.string('DRAFT'),
      name: this.string(null),
      description: this.string(''),
      approved_user: this.attr(null),
      approved_user_id: this.attr(null),
      date_approved: this.attr(null),
      date_created: this.attr(null),
      date_updated: this.attr(null),
      initiator: this.attr(null),
      brand: this.attr(null),
      brand_id: this.attr(null),
      planned_processes: this.number(null),
      planned_processes_list: this.attr([]),
      planned_recipes: this.number(null),
      planning_date_rng: this.attr({
        from: this.string(''),
        to: this.string(''),
      }),
      plant: this.attr(null),
      plant_id: this.number(null),
      product: this.attr(null),
      product_id: this.number(null),
      product_output: this.number(null),
      project: this.attr(null),
      project_id: this.number(null),
      processes: this.hasManyBy(ProcessStages, 'planned_processes_list'),
      scale: this.string(''),
      scheduled_date_rng: this.attr({
        from: this.string(''),
        to: this.string(''),
      }),
      team: this.attr(null),
      team_id: this.number(null),
      technology: this.attr(null),
      technology_id: this.number(null),
      objectives: this.attr([]),
      trialset_ids: this.attr([]),
      fullname: this.attr(null),
      meta: this.attr(null),
      type: this.string('trial'),
      assessment_pm: this.attr({}),
      assessment_plm: this.attr({})
    };
  }

  static methodConf = {
    http: {
      url: '/trials/',
      onResponse(response) {
        return !!response.data && (response.data.results || response.data);
      },
    },
    methods: {
      $fetch: {
        name: 'fetch',
        http: {
          url: '/?:query',
          method: 'get',
        },
      },
      $update: {
        name: 'update',
        http: {
          url: '/:id',
          method: 'patch',
        },
      },
    },
  };
}
